module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAbElEQVR42mNgmGnMQBJG4hgA8QNiNSQA8X8s+AAQNwCxALoGBSCeAMQfgLgAiB2AOAAqBrJ1AzYnMUBNEkATM4Da5oBNAy6MoUEB6t4DSO4G4QVQJ32A24xkSgFU0QQkjRugYgq4/EBSPBCFAWzeeRovsiKEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/icons/return_doc.png
// module id = 2075
// module chunks = 2